import { useEffect, useMemo, useState } from "react";
import { INavItem, useGlobalContext } from "../../shared/GlobalContext";
import { PanelMenu } from "primereact/panelmenu";
export function SideNav() {
  const { navItems } = useGlobalContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const [activeKey, setActiveKey] = useState<string>("");
  const [expandedKeys, setExpandedKeys] = useState<{ [key: string]: boolean }>({});
  function mapper(section: INavItem, fallbackId?: string): any {
    return {
      key: section.id,
      // label: section.label,
      // command: () => (section.items != null ? toggleItem(section.id) : scrollToSection(section.id, fallbackId)),
      className: activeKey == section.id ? "activeItem" : "",
      items: section.items?.map((i) => mapper(i, section.id)) ?? undefined,
      template: () => (
        <div className="flex p-0 m-0 sub-menu">
          <a
            href="#"
            onClick={() => scrollToSection(section.id, fallbackId)}
            tabIndex={-1}
            className={fallbackId ? "p-menuitem-link w-full" : "p-panelmenu-header-link w-full"}>
            <span className="p-menuitem-text">{section.label.trim()}</span>
          </a>{" "}
          {section.items != null && (
            <>
              <button
                className="border-none cursor-pointer p-3"
                onClick={() => {
                  toggleItem(section.id);
                }}>
                <i
                  className={
                    "border-none " + (expandedKeys[section.id] ? "pi pi-chevron-circle-down text-lg" : "pi pi-chevron-circle-left text-lg")
                  }></i>
              </button>
            </>
          )}
        </div>
      ),
    };
  }

  useEffect(() => {
    const res: { [key: string]: boolean } = {};
    navItems.forEach((item) => {
      if (item.items && item.items.length) {
        res[item.id] = true;
      }
    });
    setExpandedKeys(res);
  }, [navItems]);

  const menuItems = useMemo(() => navItems.map((i) => mapper(i)), [navItems, expandedKeys, activeKey]);

  const toggleItem = (key: string) => {
    setExpandedKeys((eK) => {
      // const copy = { ...eK };
      eK[key] = !eK[key];
      return eK;
    });
  };

  const scrollToSection = (sectionId: string, fallbackId?: string) => {
    const goTo = (el: HTMLElement) => {
      const header = document.querySelector("#page-header");
      const yOffset = header?.getBoundingClientRect()?.height ?? 0;
      const y = el.getBoundingClientRect().top + window.scrollY - yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    };
    const sectionElement = document.getElementById(sectionId);
    setActiveKey(sectionId);
    if (sectionElement) {
      goTo(sectionElement);
    } else {
      const fallbackElement = document.getElementById(fallbackId ?? "");
      if (fallbackElement) goTo(fallbackElement);
    }
  };

  return (
    <div className={`bg-grey border-right-1`}>
      <div className="sidebar sticky top-0 border-color-black bg-grey flex justify-content-center">
        <PanelMenu model={menuItems ?? []} expandedKeys={expandedKeys} />
      </div>
    </div>
  );
}
